import { queryFirst } from "../../../utils";
import { addToBasketV2 } from "./addToBasketV2";

const initAddToBasketV2 = (onAdd?: () => void) => {
  Array.from(document.body.querySelectorAll(".button.basket-button[data-add-to-basket-v2]"))
    .filter((e) => !e.hasAttribute("data-bound"))
    .map((b) => {
      return {
        element: b,
        eventId: parseInt(b.getAttribute("data-event-id")),
        productId: parseInt(b.getAttribute("data-product-id")),
        price: parseFloat(b.getAttribute("data-price")),
        zoneId: parseFloat(b.getAttribute("data-area-id")),
      };
    })
    .forEach((button) => {
      const { element, eventId, productId, zoneId, price } = button;

      const eventPageId = parseInt(document.querySelector<HTMLInputElement>("#eventPageId").value);      
      const quantityElement = queryFirst<HTMLSelectElement>(element.parentElement.parentElement, ".select-secondary .qty");

      element.setAttribute("data-bound", "");
      element.addEventListener("click", () => {
        const quantity = parseInt(quantityElement.value);
        const addPromise = addToBasketV2(element as HTMLElement, [{
          eventId,
          productId,
          zoneId,
          quantity,
          productPrice: price,
          cmsContentId: eventPageId,
        }]);

        if (!!onAdd) {
          addPromise.then(onAdd);
        }
      });
    });
};

export { initAddToBasketV2 };
